import { MovieStreamSubtitleMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformSubtitles } from '../../movie-player/transformers/transform-subtitles';

import { useFilmOtt } from './use-film-ott';

export function useSubtitles(contentId: string) {
    const film = useFilmOtt(contentId);

    const forceSubtitle = !film?.onlineStreams?.playerRestrictionConfig?.subtitlesButtonEnable;
    const metas = film?.onlineStreams?.streams?.[0]?.streamMeta?.subtitleMetas?.reduce<
        MovieStreamSubtitleMetaFragment[]
    >((acc, meta) => {
        if (meta) {
            acc.push(meta);
        }

        return acc;
    }, []);

    return {
        subtitles: transformSubtitles(metas || []),
        forceSubtitle,
    };
}
